import { useEffect, useState } from 'react';
import { getCurrency, formatCurrency, getCurrencySymbol } from '../lib/currency';

// Subscribe to currency changes and re-render.
export const useCurrency = () => {
  const [currency, setCurrencyState] = useState(getCurrency());

  useEffect(() => {
    const handler = () => setCurrencyState(getCurrency());
    window.addEventListener('currency-changed', handler);
    return () => window.removeEventListener('currency-changed', handler);
  }, []);

  return {
    currency,
    format: formatCurrency,
    symbol: currency.symbol,
    getSymbol: getCurrencySymbol,
  };
};
